export type LayoutMode = 'marketing' | 'app' | 'auth' | 'full-bleed';

type LayoutRule = {
  test: (pathname: string) => boolean;
  mode: LayoutMode;
};

const EXACT_AUTH_PATHS = new Set(['/login', '/login/finalize', '/register', '/verify']);
const EXACT_MARKETING_PATHS = new Set(['/', '/faq', '/terms-of-service', '/privacy-policy', '/agency-landing']);

const RULES: LayoutRule[] = [
  {
    test: (pathname) => EXACT_AUTH_PATHS.has(pathname),
    mode: 'auth'
  },
  {
    test: (pathname) => EXACT_MARKETING_PATHS.has(pathname),
    mode: 'marketing'
  },
  {
    test: (pathname) => pathname.startsWith('/embed/') || pathname.startsWith('/public/'),
    mode: 'full-bleed'
  }
];

export const getLayoutMode = (pathname: string): LayoutMode => {
  for (const rule of RULES) {
    if (rule.test(pathname)) {
      return rule.mode;
    }
  }

  return 'app';
};

export const shouldShowShellHeader = (mode: LayoutMode): boolean => {
  return mode !== 'full-bleed';
};

export const shouldUseSurface = (mode: LayoutMode): boolean => {
  return mode === 'app';
};
